import { isPsPOrHybrid } from '@/enums/business-model.enum'

const showMfes = store =>
  store.getters.componentIsEnabled('sidemenu', 'balance') &&
  store.getters.permissionIsEnabled('balance:view') &&
  isPsPOrHybrid(store.getters.businessModel)

export default showMfes
